import React, {useState} from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import MobileMenu from './MobileMenu';

const HeaderContainer = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 1rem;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 1px solid #eee;

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        flex-direction: row;
        justify-content: space-between;
    }
`;

const Logo = styled(Link)`
    font-size: 2rem;
    text-decoration: none;
    font-family: 'Parisienne', cursive;
    color: inherit;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        font-size: 1.5rem;
        margin-bottom: 0;
    }
`;

const LogoImage = styled.img`
    height: 80px;
    padding-right: 0.5rem;

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        height: 40px;
        padding-right: 0.5rem;
    }
`;

const LogoText = styled.span`
    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        display: block;
    }
`;

const Nav = styled.nav`
    display: flex;
    justify-content: center;

    ul {
        display: flex;
        list-style: none;
        padding: 0;
        margin: 0;
    }

    li {
        margin-left: 1rem;
    }

    a {
        text-decoration: none;
        color: inherit;
        font-size: 1rem;
    }

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        display: none;
    }
`;

const MenuIcon = styled.div`
    display: none;
    cursor: pointer;
    font-size: 1.5rem;
    color: #333;
    margin-right: 1.2em;
    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        display: block;
    }
`;

const Header: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <HeaderContainer>
            <Logo to="/">
                <LogoImage src={`${process.env.PUBLIC_URL}/logo.jpg`} alt="Mayfleur"/>
                <LogoText>Mayfleur</LogoText>
            </Logo>
            <Nav>
                <ul>
                    <li><Link to={"/"}>Home</Link></li>
                    <li><Link to={"/about"}>About</Link></li>
                    <li><Link to={"/portfolio"}>Portfolio</Link></li>
                    <li><Link to={"/class"}>Class</Link></li>
                    <li><Link to={"/shop"}>Shop</Link></li>
                    <li><Link to={"/rental"}>Rêve moiré rental</Link></li>
                    <li><Link to={"/contact"}>Contact</Link></li>
                </ul>
            </Nav>
            <MenuIcon onClick={toggleMenu}>☰</MenuIcon>
            <MobileMenu isOpen={isMenuOpen} onClose={toggleMenu}/>
        </HeaderContainer>
    );
};

export default Header;